<template>
  <products-view
    class="content"
    :vendor-id="vendorId"
    :override-list-configuration="listConfiguration"
    @crud-list:items-updated="updateItemsCount" />
  <div v-if="itemsCount > 0" class="see-all text-center">
    <saffron-link :to="linkTo">{{ t("justopp.bids.seeBidsCta") }}</saffron-link>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import ProductsView from "@/client/applications/justopp/views/Products";

export default {
  components: { ProductsView },
  props: {
    linkTo: {
      type: Object,
      default: () => ({
        name: "user-dashboard-bids",
      }),
    },
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      itemsCount: 0,
      listConfiguration: {
        showIdField: false,
        enableMassActions: false,
        fields: {
          name: {
            itemKey: "name",
            label: "justopp.vendorDeals.fields.name",
            orderable: false,
          },
          price: {
            itemKey: "price",
            label: "justopp.vendorDeals.fields.price",
            filterable: false, // boolean, or object
            orderable: false,
          },
          bidStarts: {
            itemKey: "bidStarts",
            label: "justopp.vendorDeals.fields.bidStarts",
            orderable: false,
          },
          quantity: {
            itemKey: "quantity",
            label: "justopp.vendorDeals.fields.quantity",
            filterable: false, // boolean, or object
            orderable: false,
          },
        },
        actions: false,
        paginationConfig: {
          start: 0,
          limit: 3,
          show: false,
        },
        constantFilters: {
          VendorId: this.vendorId,
          onlyLive: true,
        },
      },
    };
  },
  computed: {},
  methods: {
    updateItemsCount(items) {
      if (items) {
        this.itemsCount = items.length;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
